import axios from "axios";
import {
  IIntegratorList,
  IIntegratorUpdate,
  IIntegratorUpdateServiceParams,
} from "models/Employee/IntegratoInfo.model";
import { ITokenModel } from "models/Login/token.model";
import { IgsEnc } from "utils/gmuCrypto";

export const IntegratorList = async (
  integratorParams: ITokenModel
): Promise<IIntegratorList> => {
  const reqData = serviceIntegratorModelCreator(integratorParams);
  try {
    const { data } = await axios.post<IIntegratorList>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${integratorParams.access_token}`,
        },
      }
    );

    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;

    return data;
  } catch (error) {
    console.log(`INTEGRATOR_SERVICE_ERROR => `, error);
    throw error;
  }
};

const serviceIntegratorModelCreator = (integratorParams: ITokenModel) => {
  let req = {
    androidUID: null,
    carrier: null,
    changeKey: null,
    ChannelKey: null,
    clientDeviceID: null,
    ClientUid: null,
    connectionType: null,
    DeviceBrand: null,
    DeviceModel: null,
    deviceOs: null,
    deviceOsType: null,
    DeviceOsVersion: null,
    deviceType: null,
    deviceVersion: null,
    hardOtpFlag: false,
    imei: null,
    isCracked: null,
    softOtpFlag: null,
    kullAdiEnc: null,
    userAgent: null,
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: integratorParams.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "ModAuthGmuIntegrator/List",
  };

  return req;
};

//update integrator
export const UpdateIntegrator = async (
  params: IIntegratorUpdateServiceParams
): Promise<IIntegratorUpdate> => {
  const reqData = serviceIntegratorUpdateModelCreator(params);
  try {
    const { data } = await axios.post<IIntegratorUpdate>(
      "/api/entrypoint",
      reqData,
      {
        headers: {
          Authorization: `Bearer ${params.Token.access_token}`,
        },
      }
    );

    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;

    return data;
  } catch (error: any) {
    console.log(`INTEGRATOR_UPDATE_SERVICE_ERROR => `, error);
    return error;
  }
};

const serviceIntegratorUpdateModelCreator = (
  params: IIntegratorUpdateServiceParams
) => {
  let req = {
    Id: params.selectedIntegrator,
    PassEnc: IgsEnc(params.PassEnc),
    Username: params.Username,
    androidUID: null,
    carrier: null,
    changeKey: null,
    ChannelKey: null,
    clientDeviceID: null,
    ClientUid: null,
    connectionType: null,
    DeviceBrand: null,
    DeviceModel: null,
    deviceOs: null,
    deviceOsType: null,
    DeviceOsVersion: null,
    deviceType: null,
    deviceVersion: null,
    hardOtpFlag: false,
    imei: null,
    isCracked: null,
    softOtpFlag: null,
    kullAdiEnc: null,
    userAgent: null,
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: params.Token.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "ModAuthGmuIntegrator/Confirm",
  };

  return req;
};
